import { jsx as o } from "react/jsx-runtime";
import { createContext as a, useMemo as i } from "react";
import c from "./globalstyles.module.js";
const r = "Tillsatser", _ = "Vinets syra", l = "Syror i gram per liter", u = "Alkoholens ålder", A = "år", E = "Vinkropp", d = "Alkoholens färg", m = "Vörtsstyrka", F = "Alkoholprocent", p = "Subregion", $ = "Alkoholens sockerhalt", h = "Alkoholens sötmanivå", R = "Tanniner", f = "Alkoholtyp", T = "Årgång", I = "Vinproducent", g = "Allergener", N = "Vi rekommenderar att du kontrollerar allergeninformationen på produktens förpackningsetikett.", O = "Attribut", S = "Brödsmula", k = "Varumärke", L = "Kolla priser i vår webbutik", C = "Bli kund", y = "Är du en återkommande eller en ny kund?", v = "Är du en konsument? Byt till K-Ruoka.fi webbutik", b = "Tillverkningsland", M = "Produktstorlek", V = "Dietinformation", U = "Fettinnehåll i torrsubstans", G = "Fettinnehåll i mjölk", D = "Fil", B = "Filer", H = "Fiskeområde", P = "Fiskeland", K = "Fiskemetod", w = "Fiskeinformation", j = "Artnamn", W = "Produktionsmetod", Y = "Vetenskapligt namn", x = "Produktens frysstadier", J = "Innehåll av kött/fisk", z = "Dölj", X = "Ingredienser", Z = "Hållbarhet för öppnad produkt", q = "Förberedelseinstruktioner", Q = "Avkastning av tillagad produkt", tt = "Hållbarhet från produktion", nt = "Serveringsförslag", ot = "Förvaring", it = "Bruksanvisning", st = "Obligatoriska tilläggsanmärkningar för konsumenten", et = "Juiceinnehåll", at = "Marknadsförare", ct = "Laddar", rt = "Tillverkare", _t = "Mått", lt = "Media inte tillgängligt", ut = "Näringsvärde", At = "Näringsvärde (otillagad)", Et = "Näringspåståenden", dt = "Näringsinformation", mt = "Producent", Ft = "Konsumentstöd", pt = "Produktionsstegens länder", $t = "Försäljningspartier", ht = "Första media", Rt = "Nästa media", ft = "Föregående media", Tt = "Senaste media", It = "Produktinformation", gt = "Upptäck mer", Nt = "Koldioxidavtryck", Ot = "Ansvar för palmolja", St = "Ansvar för soja", kt = "Vattenavtryck", Lt = "m3 / år", Ct = "CBAM-produktkod", yt = "Ja", vt = "Nej", bt = "Eläinsuojelulinjaus", Mt = "Keskon eläinsuojelulinjauksen mukaisesti tuotteen sisältämä kananmuna vapaan kanan munista, luomukananmunista tai ulkokananmunista.", Vt = "Säkerhetsinformation", Ut = "Visa allt", Gt = "Användning och förvaring", Dt = "Paketmarkeringar", Bt = "Garanti information", Ht = "Kvalitetscertifikationer", Pt = "Organisk kvalitetscertifikationer", Kt = "Ingrediensdetaljer", wt = "Visa fler partier", jt = "Materiale", Wt = "Aminosyror", Yt = "Aska (mineraler)", xt = "Biotin (Vitamin B7)", Jt = "Kalcium", zt = "Betakaroten", Xt = "Koffein", Zt = "Fett, varav kolesterol", qt = "Kolhydrater", Qt = "Klorid", tn = "Krom", nn = "Kollagen", on = "Koppar", sn = "Kolesterol", en = "Energi", an = "varav enkelomättade fetter", cn = "varav fleromättade fetter", rn = "Omega-3", _n = "Omega-6", ln = "varav mättat fett", un = "Fett", An = "Fluorid", En = "Järn", dn = "Kostfiber", mn = "Folsyra", Fn = "Folat, kostfolatekvivalenter", pn = "Fruktos", $n = "Nikotin", hn = "Betaglukan", Rn = "Ginseng", fn = "Beta-hydroxi-beta-metylbutyrat", Tn = "Jod", In = "Kalium", gn = "Kolhydrat, varav laktos", Nn = "Karnitin", On = "Magnesium", Sn = "Molybden", kn = "Mangan", Ln = "Natrium", Cn = "Salt", yn = "Niacin (Vitamin B3)", vn = "Nukleotid", bn = "Oligosackarid", Mn = "Fosfor", Vn = "Pantotensyra (Vitamin B5)", Un = "varav sockeralkoholer (polyoler)", Gn = "Riboflavin (Vitamin B2)", Dn = "Salt", Bn = "Selen", Hn = "varav stärkelse", Pn = "varav sockerarter", Kn = "Taurin", wn = "Tiamin (Vitamin B1)", jn = "Ospecificerad", Wn = "Kobalamin (Vitamin B12)", Yn = "Vitamin C", xn = "Vitamin D", Jn = "Vitamin E", zn = "Vitamin K", Xn = "Mättade och transfetter kombinerat", Zn = "Melatonin", qn = "Zink", Qn = "Vatten", to = "Gott från Finland", no = "Hjärtmärket", oo = "Vegan", io = "Nyckelflaggan", so = "EU:s eko-märke", eo = "EU Ecolabel", ao = "Fairtrade", co = "Rainforest Alliance", ro = "Rainforest Alliance", _o = "Kespro är medlem i Forrest Alliance. Läs mer på", lo = "Rainforest Alliance märket", uo = "Hjärtbladsmärket", Ao = "Miljomärket Svanen", Eo = "Stänga", mo = "Säkerhetsdatablad", Fo = "Förklaring om överensstämmelse", po = "Bruksanvisning", $o = {
  additives: r,
  alcohol_acidities: _,
  alcohol_acidity_per_gram: l,
  alcohol_age: u,
  alcohol_age_unit: A,
  alcohol_bodies: E,
  alcohol_color: d,
  alcohol_degree_of_wort: m,
  alcohol_percentage: F,
  alcohol_subregion: p,
  alcohol_sugar_content: $,
  alcohol_sweetness_level: h,
  alcohol_tannins: R,
  alcohol_type: f,
  alcohol_vintage: T,
  alcohol_vintner: I,
  allergens: g,
  allergens_disclaimer: N,
  attributes: O,
  breadcrumb: S,
  brand_name: k,
  client_outreach_check_prices: L,
  client_outreach_onboarding: C,
  client_outreach_question: y,
  client_outreach_url_text: v,
  country_of_origin: b,
  descriptive_size: M,
  diets: V,
  dry_matter: U,
  fat_in_milk: G,
  file: D,
  files: B,
  fishing_catch_area: H,
  fishing_catch_country: P,
  fishing_catch_method: K,
  fishing_info: w,
  fishing_name: j,
  fishing_prod_method: W,
  fishing_scientific_name: Y,
  fishing_storage_states: x,
  fish_meat_poultries: J,
  hide: z,
  ingredients: X,
  instructions_opened_life_span: Z,
  instructions_preparation: q,
  instructions_product_yield: Q,
  instructions_production_life_span: tt,
  instructions_serving: nt,
  instructions_storage: ot,
  instructions_usage: it,
  instructions_compulsory_additives: st,
  juice_content: et,
  licensee_registrar: at,
  loading: ct,
  manufacturer: rt,
  measurements: _t,
  not_found: lt,
  nut_table_nutritional_content: ut,
  nut_table_nutritional_content_unprepared: At,
  nutritional_claims: Et,
  nutritional_content: dt,
  produced_for: mt,
  consumer_support: Ft,
  product_activities: pt,
  product_batches: $t,
  product_carousel_first: ht,
  product_carousel_next: Rt,
  product_carousel_prev: ft,
  product_carousel_last: Tt,
  product_info: It,
  recommended_products: gt,
  responsibility_carbon_footprint: Nt,
  responsibility_palm_oil: Ot,
  responsibility_soy: St,
  responsibility_water_footprint: kt,
  responsibility_water_footprint_unit: Lt,
  responsibility_cbam_product_code: Ct,
  responsibility_cbam_product_code_unit_true: yt,
  responsibility_cbam_product_code_unit_false: vt,
  responsibility_animal_welfare_title: bt,
  responsibility_animal_welfare_content: Mt,
  safety_info: Vt,
  show_everything: Ut,
  use_and_storage: Gt,
  packaging_markings: Dt,
  warranties: Bt,
  certifications: Ht,
  organic_certifications: Pt,
  product_ingredient_details: Kt,
  show_more_batches: wt,
  materials: jt,
  "5FTHF": "5-Formyltetrahydrofolat",
  AATN: Wt,
  ASH: Yt,
  BIOT: xt,
  CA: Jt,
  CARTB: zt,
  CAFFN: Xt,
  "CHOL-": "Fett, varav kolesterol",
  CHOLC: Zt,
  CHOAVL: qt,
  CLD: Qt,
  CR: tn,
  COLG: nn,
  CU: on,
  CHOLE: sn,
  "ENER-": "Energi",
  ENERKJO: en,
  FAMSCIS: an,
  FAPUCIS: cn,
  FAPUN3F: rn,
  FAPUN6F: _n,
  FASAT: ln,
  FAT: un,
  FD: An,
  FE: En,
  FIBTG: dn,
  FOL: mn,
  FOLDFE: Fn,
  FRUS: pn,
  G_NICT: $n,
  GLUCNB: hn,
  GINSENG: Rn,
  HMB: fn,
  ID: Tn,
  K: In,
  LACS: gn,
  L_CARNITINE: Nn,
  MG: On,
  MO: Sn,
  MN: kn,
  NA: Ln,
  NACL: Cn,
  NIA: yn,
  NUCLEOTIDE: vn,
  OLSAC: bn,
  P: Mn,
  PANTAC: Vn,
  POLYL: Un,
  "PRO-": "Protein",
  RIBF: Gn,
  SALTEQ: Dn,
  SE: Bn,
  STARCH: Hn,
  SUGAR: Pn,
  "SUGAR-": "varav sockerarter",
  TAU: Kn,
  THIA: wn,
  UNSPECIFIED: jn,
  "VITA-": "Vitamin A",
  VITB12: Wn,
  "VITB6-": "Pyridoxin (Vitamin B6)",
  VITC: Yn,
  "VITC-": "Vitamin C",
  VITD: xn,
  "VITD-": "Vitamin D",
  VITE: Jn,
  "VITE-": "Vitamin E",
  VITK: zn,
  X_FATRSA: Xn,
  X_MELA: Zn,
  ZN: qn,
  WATER: Qn,
  "CONTAINS-NUTS": "Innehåller nötter",
  "FREE_FROM-ADDITIVES": "Fri från tillsatser",
  "FREE_FROM-ALCOHOL": "Alkoholfri",
  "FREE_FROM-ANTIBIOTICS": "Fri från antibiotika",
  "FREE_FROM-AZO_DYE": "Innehåller inte azofärger",
  "FREE_FROM-CAFFEINE": "Koffeinfri",
  "FREE_FROM-COLOURING_AGENTS": "Ingen tillsatt färg",
  "FREE_FROM-EGGS": "Äggfri",
  "FREE_FROM-ENERGY": "Energifri",
  "FREE_FROM-FAT": "Fettfri",
  "FREE_FROM-GELATINE": "Gelatinfri",
  "FREE_FROM-GLUTEN": "Glutenfri",
  "FREE_FROM-LACTOSE": "Laktosfri",
  "FREE_FROM-MILK": "Mjölkfri",
  "FREE_FROM-NUTS": "Nötfri",
  "FREE_FROM-PORK_GELATINE": "Fri från grisgelatin",
  "FREE_FROM-BEEF_GELATINE": "Fri från nötköttgelatin",
  "FREE_FROM-PRESERVATIVES": "Fri från konserveringsmedel",
  "FREE_FROM-SODIUM_SALT": "Saltfri",
  "FREE_FROM-SUGARS": "Sockerfri",
  "FREE_FROM-YEAST": "Jästfri",
  "HIGH-FIBRE": "Hög i fiber",
  "HIGH-SODIUM_SALT": "Hög i salt",
  "LOW-FAT": "Låg fetthalt",
  "LOW-LACTOSE": "Låglaktos",
  "LOW-SATURATED_FAT": "Låg i mättade fetter",
  "LOW-SODIUM_SALT": "Låg i natrium/Lågsalt",
  "LOW-SUGARS": "Låg sockerhalt",
  "NO_ADDED-SUGARS": "Inget tillsatt socker",
  GOODS_FROM_FINLAND_BLUE_SWAN: to,
  FINNISH_HEART_SYMBOL: no,
  VEGAN: oo,
  MADE_IN_FINLAND_FLAG_WITH_KEY: io,
  EU_ORGANIC_FARMING: so,
  EU_ECO_LABEL: eo,
  FAIR_TRADE_MARK: ao,
  RAINFOREST_ALLIANCE: co,
  RAINFOREST_ALLIANCE_PEOPLE_NATURE: ro,
  RAINFOREST_ALLIANCE_INFO: _o,
  RAINFOREST_ALLIANCE_ICON: lo,
  PUHTAASTI_KOTIMAINEN: uo,
  SVANEN: Ao,
  close: Eo,
  SAFETY_DATA_SHEET: mo,
  FOOD_CONTACT_CONFORMITY_CERTIFICATE: Fo,
  IFU: po
}, ho = "Additives", Ro = "Wine acidity", fo = "Acids in grams per liter", To = "Alcohol age", Io = "yr", go = "Wine body", No = "Alcohol color", Oo = "Degree of wort", So = "Alcohol percentage", ko = "Subregion", Lo = "Alcohol sugar content", Co = "Alcohol sweetness level", yo = "Tannins", vo = "Alcohol type", bo = "Vintage", Mo = "Wine producer", Vo = "Allergens", Uo = "We recommend to check the allergen information on the product's packaging label.", Go = "Attributes", Do = "Breadcrumb", Bo = "Brand", Ho = "Check prices on our online store", Po = "Become a customer", Ko = "Are you a returning or a new customer?", wo = "Are you a consumer? Switch to the K-Ruoka.fi store", jo = "Country of manufacture", Wo = "Product size", Yo = "Diet information", xo = "Fat content in dry matter", Jo = "Fat content in milk", zo = "File", Xo = "Files", Zo = "Fishing area", qo = "Fishing country", Qo = "Fishing method", ti = "Fishing information", ni = "Species name", oi = "Production method", ii = "Scientific name", si = "Product freezing states", ei = "Meat/fish content", ai = "Hide", ci = "Ingredients", ri = "Item lifespan after opening", _i = "Preparation instructions", li = "Prepared product yields", ui = "Shelf life from production", Ai = "Serving suggestion", Ei = "Storage", di = "Instructions for use", mi = "Compulsory additive information for consumers", Fi = "Juice content", pi = "Marketer", $i = "Loading", hi = "Manufacturer", Ri = "Measurements", fi = "Media not available", Ti = "Nutritional value", Ii = "Nutritional value (unprepared)", gi = "Nutritional claims", Ni = "Nutritional information", Oi = "Producer", Si = "Consumer support", ki = "Countries of production stages", Li = "Sales batches", Ci = "First media", yi = "Next media", vi = "Previous media", bi = "Last media", Mi = "Product information", Vi = "Discover more", Ui = "Carbon footprint", Gi = "Palm oil responsibility", Di = "Soy responsibility", Bi = "Water footprint", Hi = "m3 / year", Pi = "CBAM product code", Ki = "Yes", wi = "No", ji = "Eläinsuojelulinjaus", Wi = "Keskon eläinsuojelulinjauksen mukaisesti tuotteen sisältämä kananmuna vapaan kanan munista, luomukananmunista tai ulkokananmunista.", Yi = "Safety information", xi = "Show all", Ji = "Use and storage", zi = "Packaging markings", Xi = "Warranty information", Zi = "Certifications", qi = "Organic certifications", Qi = "Ingredient details", ts = "Show more batch sizes", ns = "Materials", os = "Amino acids", is = "Ash (minerals)", ss = "Biotin (Vitamin B7)", es = "Calcium", as = "Beta-carotene", cs = "Caffeine", rs = "Fat, from which cholesterol", _s = "Carbohydrates", ls = "Chloride", us = "Chromium", As = "Collagen", Es = "Copper", ds = "Cholesterol", ms = "Energy", Fs = "from which monounsaturated fats", ps = "from which polyunsaturated fats", $s = "Omega-3", hs = "Omega-6", Rs = "from which saturated", fs = "Fat", Ts = "Fluoride", Is = "Iron", gs = "Dietary fiber", Ns = "Folic acid", Os = "Folate, dietary folate equivalents", Ss = "Fructose", ks = "Nicotine", Ls = "Beta-glucan", Cs = "Ginseng", ys = "Beta-hydroxy-beta-methylbutyrate", vs = "Iodine", bs = "Potassium", Ms = "Carbohydrate, from which lactose", Vs = "Carnitine", Us = "Magnesium", Gs = "Molybdenum", Ds = "Manganese", Bs = "Sodium", Hs = "Salt", Ps = "Niacin (Vitamin B3)", Ks = "Nucleotide", ws = "Oligosaccharide", js = "Phosphorus", Ws = "Pantothenic acid (Vitamin B5)", Ys = "from which sugar alcohols (polyols)", xs = "Riboflavin (Vitamin B2)", Js = "Salt", zs = "Selenium", Xs = "from which starch", Zs = "from which sugars", qs = "Taurine", Qs = "Thiamine (Vitamin B1)", te = "Unspecified", ne = "Cobalamin (Vitamin B12)", oe = "Vitamin C", ie = "Vitamin D", se = "Vitamin E", ee = "Vitamin K", ae = "Saturated and trans fats combined", ce = "Melatonin", re = "Zinc", _e = "Water", le = "Produce of Finland", ue = "Heart Symbol", Ae = "Vegan", Ee = "Key Flag", de = "EU Organic Label", me = "EU Ecolabel", Fe = "Fairtrade", pe = "Rainforest Alliance", $e = "Rainforest Alliance", he = "Kespro is a member of Forrest Alliance. Read more at", Re = "Rainforst Alliance icon", fe = "Sirkkalehti Label", Te = "The Nordic Swan Ecolabel", Ie = "Close", ge = "Safety Data Sheet", Ne = "Food Contact Declaration of Compliance", Oe = "Instructions For Use", Se = {
  additives: ho,
  alcohol_acidities: Ro,
  alcohol_acidity_per_gram: fo,
  alcohol_age: To,
  alcohol_age_unit: Io,
  alcohol_bodies: go,
  alcohol_color: No,
  alcohol_degree_of_wort: Oo,
  alcohol_percentage: So,
  alcohol_subregion: ko,
  alcohol_sugar_content: Lo,
  alcohol_sweetness_level: Co,
  alcohol_tannins: yo,
  alcohol_type: vo,
  alcohol_vintage: bo,
  alcohol_vintner: Mo,
  allergens: Vo,
  allergens_disclaimer: Uo,
  attributes: Go,
  breadcrumb: Do,
  brand_name: Bo,
  client_outreach_check_prices: Ho,
  client_outreach_onboarding: Po,
  client_outreach_question: Ko,
  client_outreach_url_text: wo,
  country_of_origin: jo,
  descriptive_size: Wo,
  diets: Yo,
  dry_matter: xo,
  fat_in_milk: Jo,
  file: zo,
  files: Xo,
  fishing_catch_area: Zo,
  fishing_catch_country: qo,
  fishing_catch_method: Qo,
  fishing_info: ti,
  fishing_name: ni,
  fishing_prod_method: oi,
  fishing_scientific_name: ii,
  fishing_storage_states: si,
  fish_meat_poultries: ei,
  hide: ai,
  ingredients: ci,
  instructions_opened_life_span: ri,
  instructions_preparation: _i,
  instructions_product_yield: li,
  instructions_production_life_span: ui,
  instructions_serving: Ai,
  instructions_storage: Ei,
  instructions_usage: di,
  instructions_compulsory_additives: mi,
  juice_content: Fi,
  licensee_registrar: pi,
  loading: $i,
  manufacturer: hi,
  measurements: Ri,
  not_found: fi,
  nut_table_nutritional_content: Ti,
  nut_table_nutritional_content_unprepared: Ii,
  nutritional_claims: gi,
  nutritional_content: Ni,
  produced_for: Oi,
  consumer_support: Si,
  product_activities: ki,
  product_batches: Li,
  product_carousel_first: Ci,
  product_carousel_next: yi,
  product_carousel_prev: vi,
  product_carousel_last: bi,
  product_info: Mi,
  recommended_products: Vi,
  responsibility_carbon_footprint: Ui,
  responsibility_palm_oil: Gi,
  responsibility_soy: Di,
  responsibility_water_footprint: Bi,
  responsibility_water_footprint_unit: Hi,
  responsibility_cbam_product_code: Pi,
  responsibility_cbam_product_code_unit_true: Ki,
  responsibility_cbam_product_code_unit_false: wi,
  responsibility_animal_welfare_title: ji,
  responsibility_animal_welfare_content: Wi,
  safety_info: Yi,
  show_everything: xi,
  use_and_storage: Ji,
  packaging_markings: zi,
  warranties: Xi,
  certifications: Zi,
  organic_certifications: qi,
  product_ingredient_details: Qi,
  show_more_batches: ts,
  materials: ns,
  "5FTHF": "5-Formyltetrahydrofolate",
  AATN: os,
  ASH: is,
  BIOT: ss,
  CA: es,
  CARTB: as,
  CAFFN: cs,
  "CHOL-": "Fat, from which cholesterol",
  CHOLC: rs,
  CHOAVL: _s,
  CLD: ls,
  CR: us,
  COLG: As,
  CU: Es,
  CHOLE: ds,
  "ENER-": "Energy",
  ENERKJO: ms,
  FAMSCIS: Fs,
  FAPUCIS: ps,
  FAPUN3F: $s,
  FAPUN6F: hs,
  FASAT: Rs,
  FAT: fs,
  FD: Ts,
  FE: Is,
  FIBTG: gs,
  FOL: Ns,
  FOLDFE: Os,
  FRUS: Ss,
  G_NICT: ks,
  GLUCNB: Ls,
  GINSENG: Cs,
  HMB: ys,
  ID: vs,
  K: bs,
  LACS: Ms,
  L_CARNITINE: Vs,
  MG: Us,
  MO: Gs,
  MN: Ds,
  NA: Bs,
  NACL: Hs,
  NIA: Ps,
  NUCLEOTIDE: Ks,
  OLSAC: ws,
  P: js,
  PANTAC: Ws,
  POLYL: Ys,
  "PRO-": "Protein",
  RIBF: xs,
  SALTEQ: Js,
  SE: zs,
  STARCH: Xs,
  SUGAR: Zs,
  "SUGAR-": "from which sugars",
  TAU: qs,
  THIA: Qs,
  UNSPECIFIED: te,
  "VITA-": "Vitamin A",
  VITB12: ne,
  "VITB6-": "Pyridoxine (Vitamin B6)",
  VITC: oe,
  "VITC-": "Vitamin C",
  VITD: ie,
  "VITD-": "Vitamin D",
  VITE: se,
  "VITE-": "Vitamin E",
  VITK: ee,
  X_FATRSA: ae,
  X_MELA: ce,
  ZN: re,
  WATER: _e,
  "CONTAINS-NUTS": "Contains nuts",
  "FREE_FROM-ADDITIVES": "Additive-free",
  "FREE_FROM-ALCOHOL": "Alcohol-free",
  "FREE_FROM-ANTIBIOTICS": "Antibiotic-free",
  "FREE_FROM-AZO_DYE": "Does not contain azo dyes",
  "FREE_FROM-CAFFEINE": "Caffeine-free",
  "FREE_FROM-COLOURING_AGENTS": "No added color",
  "FREE_FROM-EGGS": "Egg-free",
  "FREE_FROM-ENERGY": "Energy-free",
  "FREE_FROM-FAT": "Fat-free",
  "FREE_FROM-GELATINE": "Gelatin-free",
  "FREE_FROM-GLUTEN": "Gluten-free",
  "FREE_FROM-LACTOSE": "Lactose-free",
  "FREE_FROM-MILK": "Milk-free",
  "FREE_FROM-NUTS": "Nut-free",
  "FREE_FROM-PORK_GELATINE": "Free from pork gelatin",
  "FREE_FROM-BEEF_GELATINE": "Free from beef gelatin",
  "FREE_FROM-PRESERVATIVES": "Preservative-free",
  "FREE_FROM-SODIUM_SALT": "Salt-free",
  "FREE_FROM-SUGARS": "Sugar-free",
  "FREE_FROM-YEAST": "Yeast-free",
  "HIGH-FIBRE": "High in fiber",
  "HIGH-SODIUM_SALT": "High in salt",
  "LOW-FAT": "Low-fat",
  "LOW-LACTOSE": "Low-lactose",
  "LOW-SATURATED_FAT": "Low in saturated fats",
  "LOW-SODIUM_SALT": "Low in sodium/Low-salt",
  "LOW-SUGARS": "Low in sugar",
  "NO_ADDED-SUGARS": "No added sugar",
  GOODS_FROM_FINLAND_BLUE_SWAN: le,
  FINNISH_HEART_SYMBOL: ue,
  VEGAN: Ae,
  MADE_IN_FINLAND_FLAG_WITH_KEY: Ee,
  EU_ORGANIC_FARMING: de,
  EU_ECO_LABEL: me,
  FAIR_TRADE_MARK: Fe,
  RAINFOREST_ALLIANCE: pe,
  RAINFOREST_ALLIANCE_PEOPLE_NATURE: $e,
  RAINFOREST_ALLIANCE_INFO: he,
  RAINFOREST_ALLIANCE_ICON: Re,
  PUHTAASTI_KOTIMAINEN: fe,
  SVANEN: Te,
  close: Ie,
  SAFETY_DATA_SHEET: ge,
  FOOD_CONTACT_CONFORMITY_CERTIFICATE: Ne,
  IFU: Oe
}, ke = "Lisäaineet", Le = "Viinin hapokkuus", Ce = "Hapot grammoina per litra", ye = "Alkoholin ikä", ve = "v", be = "Viinin täyteläisyys", Me = "Alkoholin väri", Ve = "Kantavierteen aste", Ue = "Alkoholiprosentti", Ge = "Ala-alue", De = "Alkoholin sokeripitoisuus", Be = "Alkoholin makeusaste", He = "Tanniinisuus", Pe = "Alkoholin tyyppi", Ke = "Vuosikerta", we = "Viinin tuottaja", je = "Allergeenit", We = "Tarkista tuotteen allergeenitiedot aina myös pakkauksesta.", Ye = "Tuotetta kuvaavat tiedot", xe = "Murupolku", Je = "Merkki", ze = "Tarkista hinnat verkkokaupasta", Xe = "Tule asiakkaaksi", Ze = "Oletko nykyinen tai uusi asiakas?", qe = "Oletko kuluttaja? Siirry K-Ruoka.fi -verkkokaupaan", Qe = "Valmistusmaa", ta = "Tuotteen koko", na = "Ruokavaliotieto", oa = "Kuiva-aineen rasvapitoisuus", ia = "Maidon rasvapitoisuus", sa = "Tiedosto", ea = "Tiedostot", aa = "Pyyntialue", ca = "Kalastusmaa", ra = "Pyyntitapa", _a = "Kalastustiedot", la = "Lajin nimi", ua = "Tuotantomenetelmä", Aa = "Lajin tieteellinen nimi", Ea = "Tuotteen pakastus", da = "Liha-/kalapitoisuus", ma = "Piilota", Fa = "Ainesosat", pa = "Käyttöohje", $a = "Valmistusohje", ha = "Tarjoiluehdotus", Ra = "Valmista tuotetta", fa = "Säilytys", Ta = "Säilyvyysaika avaamisesta", Ia = "Säilyvyysaika valmistuksesta", ga = "Pakolliset lisähuomautukset kuluttajalle", Na = "Mehupitoisuus", Oa = "Markkinoija", Sa = "Lataa", ka = "Valmistaja", La = "Mittatiedot", Ca = "Media ei saatavilla", ya = "Ravintoarvo", va = "Ravintoarvo (valmistamattomana)", ba = "Ravitsemukselliset ominaisuudet", Ma = "Ravintoarvo- ja koostumustiedot", Va = "Valmistuttaja", Ua = "Kuluttajapalvelu", Ga = "Tuotteen tuotantovaiheiden toteutusmaat", Da = "Myyntierät", Ba = "Ensimmäinen media", Ha = "Seuraava media", Pa = "Edellinen media", Ka = "Viimeinen media", wa = "Tuotetiedot", ja = "Tutustu myös näihin", Wa = "Hiilijalanjälki", Ya = "Palmuöljyn vastuullisuus", xa = "Soijan vastuullisuus", Ja = "Vesijalanjälki", za = "m3 / vuosi", Xa = "CBAM-tuotekoodi", Za = "Kyllä", qa = "Ei", Qa = "Eläinsuojelulinjaus", tc = "Keskon eläinsuojelulinjauksen mukaisesti tuotteen sisältämä kananmuna vapaan kanan munista, luomukananmunista tai ulkokananmunista.", nc = "Käyttöturvallisuustiedot", oc = "Näytä kaikki", ic = "Käyttö ja säilytys", sc = "Pakkausmerkinnät", ec = "Takuutiedot", ac = "Sertifikaatit", cc = "Luomusertifikaatit", rc = "Ainesosien tiedot", _c = "Näytä lisää myyntieriä", lc = "Materiaalit", uc = "Aminohapot", Ac = "Tuhka (kivennäisaineet)", Ec = "Biotiini (B7-vitamiini)", dc = "Kalsium", mc = "Beetakaroteeni", Fc = "Kofeiini", pc = "Rasvaa josta kolesterolia", $c = "Hiilihydraatit", hc = "Kloridi", Rc = "Kromi", fc = "Kollageeni", Tc = "Kupari", Ic = "Kolesteroli", gc = "Energia", Nc = "josta kertatyydyttymättömiä rasvoja", Oc = "josta monityydyttymättömiä rasvoja", Sc = "Omega-3", kc = "Omega-6", Lc = "josta tyydyttynyttä", Cc = "Rasva", yc = "Fluori", vc = "Rauta", bc = "Ravintokuitu", Mc = "Foolihappo", Vc = "Folaatti, ravinnon folaattivastineet", Uc = "Fruktoosi", Gc = "Nikotiini", Dc = "Betaglukaani", Bc = "Ginseng", Hc = "Beeta-hydroksi-beeta-metyylibutyraatti", Pc = "Jodi", Kc = "Kalium", wc = "Hiilihydraattia, josta laktoosia", jc = "Karnitiini", Wc = "Magnesium", Yc = "Molybdeeni", xc = "Mangaani", Jc = "Natrium", zc = "Suola", Xc = "Niasiini (B3-vitamiini)", Zc = "Nukleotidi", qc = "Oligosakkaridit", Qc = "Fosfori", tr = "Pantoteenihappo (B5-vitamiini)", nr = "josta sokerialkoholeja (polyolit)", or = "Riboflaviini (B2-vitamiini)", ir = "Suola", sr = "Seleeni", er = "josta tärkkelystä", ar = "josta sokereita", cr = "Tauriini", rr = "Tiamiini (B1-vitamiini)", _r = "Määrittelemätön", lr = "Kobalamiini (B12-vitamiini)", ur = "C-vitamiini", Ar = "D-vitamiini", Er = "E-vitamiini", dr = "K-vitamiini", mr = "Tyydyttynyt- ja transrasva yhteensä", Fr = "Melatoniini", pr = "Sinkki", $r = "Vettä", hr = "Hyvää Suomesta", Rr = "Sydänmerkki", fr = "Vegaaninen", Tr = "Avainlippu", Ir = "EU:n luomutunnus", gr = "EU-ympäristömerkki", Nr = "Reilu kauppa", Or = "Rainforest Alliance", Sr = "Rainforest Alliance", kr = "Kespro on Forest Alliancen jäsen. Lue lisää osoitteessa", Lr = "Forest Alliance -ikoni", Cr = "Sirkkalehtimerkki", yr = "Joutsenmerkki", vr = "Sulje", br = "Käyttöturvallisuustiedote", Mr = "Elintarvikekelpoisuustodistus", Vr = "Käyttöohjeet", Ur = {
  additives: ke,
  alcohol_acidities: Le,
  alcohol_acidity_per_gram: Ce,
  alcohol_age: ye,
  alcohol_age_unit: ve,
  alcohol_bodies: be,
  alcohol_color: Me,
  alcohol_degree_of_wort: Ve,
  alcohol_percentage: Ue,
  alcohol_subregion: Ge,
  alcohol_sugar_content: De,
  alcohol_sweetness_level: Be,
  alcohol_tannins: He,
  alcohol_type: Pe,
  alcohol_vintage: Ke,
  alcohol_vintner: we,
  allergens: je,
  allergens_disclaimer: We,
  attributes: Ye,
  breadcrumb: xe,
  brand_name: Je,
  client_outreach_check_prices: ze,
  client_outreach_onboarding: Xe,
  client_outreach_question: Ze,
  client_outreach_url_text: qe,
  country_of_origin: Qe,
  descriptive_size: ta,
  diets: na,
  dry_matter: oa,
  fat_in_milk: ia,
  file: sa,
  files: ea,
  fishing_catch_area: aa,
  fishing_catch_country: ca,
  fishing_catch_method: ra,
  fishing_info: _a,
  fishing_name: la,
  fishing_prod_method: ua,
  fishing_scientific_name: Aa,
  fishing_storage_states: Ea,
  fish_meat_poultries: da,
  hide: ma,
  ingredients: Fa,
  instructions_usage: pa,
  instructions_preparation: $a,
  instructions_serving: ha,
  instructions_product_yield: Ra,
  instructions_storage: fa,
  instructions_opened_life_span: Ta,
  instructions_production_life_span: Ia,
  instructions_compulsory_additives: ga,
  juice_content: Na,
  licensee_registrar: Oa,
  loading: Sa,
  manufacturer: ka,
  measurements: La,
  not_found: Ca,
  nut_table_nutritional_content: ya,
  nut_table_nutritional_content_unprepared: va,
  nutritional_claims: ba,
  nutritional_content: Ma,
  produced_for: Va,
  consumer_support: Ua,
  product_activities: Ga,
  product_batches: Da,
  product_carousel_first: Ba,
  product_carousel_next: Ha,
  product_carousel_prev: Pa,
  product_carousel_last: Ka,
  product_info: wa,
  recommended_products: ja,
  responsibility_carbon_footprint: Wa,
  responsibility_palm_oil: Ya,
  responsibility_soy: xa,
  responsibility_water_footprint: Ja,
  responsibility_water_footprint_unit: za,
  responsibility_cbam_product_code: Xa,
  responsibility_cbam_product_code_unit_true: Za,
  responsibility_cbam_product_code_unit_false: qa,
  responsibility_animal_welfare_title: Qa,
  responsibility_animal_welfare_content: tc,
  safety_info: nc,
  show_everything: oc,
  use_and_storage: ic,
  packaging_markings: sc,
  warranties: ec,
  certifications: ac,
  organic_certifications: cc,
  product_ingredient_details: rc,
  show_more_batches: _c,
  materials: lc,
  "5FTHF": "5-Formyltetrahydrofolaatti",
  AATN: uc,
  ASH: Ac,
  BIOT: Ec,
  CA: dc,
  CARTB: mc,
  CAFFN: Fc,
  "CHOL-": "Rasvaa, josta kolesterolia",
  CHOLC: pc,
  CHOAVL: $c,
  CLD: hc,
  CR: Rc,
  COLG: fc,
  CU: Tc,
  CHOLE: Ic,
  "ENER-": "Energia",
  ENERKJO: gc,
  FAMSCIS: Nc,
  FAPUCIS: Oc,
  FAPUN3F: Sc,
  FAPUN6F: kc,
  FASAT: Lc,
  FAT: Cc,
  FD: yc,
  FE: vc,
  FIBTG: bc,
  FOL: Mc,
  FOLDFE: Vc,
  FRUS: Uc,
  G_NICT: Gc,
  GLUCNB: Dc,
  GINSENG: Bc,
  HMB: Hc,
  ID: Pc,
  K: Kc,
  LACS: wc,
  L_CARNITINE: jc,
  MG: Wc,
  MO: Yc,
  MN: xc,
  NA: Jc,
  NACL: zc,
  NIA: Xc,
  NUCLEOTIDE: Zc,
  OLSAC: qc,
  P: Qc,
  PANTAC: tr,
  POLYL: nr,
  "PRO-": "Proteiini",
  RIBF: or,
  SALTEQ: ir,
  SE: sr,
  STARCH: er,
  SUGAR: ar,
  "SUGAR-": "josta sokereita",
  TAU: cr,
  THIA: rr,
  UNSPECIFIED: _r,
  "VITA-": "A-vitamiini",
  VITB12: lr,
  "VITB6-": "Pyridoksiini (B6-vitamiini)",
  VITC: ur,
  "VITC-": "C-vitamiini",
  VITD: Ar,
  "VITD-": "D-vitamiini",
  VITE: Er,
  "VITE-": "E-vitamiini",
  VITK: dr,
  X_FATRSA: mr,
  X_MELA: Fr,
  ZN: pr,
  WATER: $r,
  "CONTAINS-NUTS": "Sisältää pähkinää",
  "FREE_FROM-ADDITIVES": "Lisäaineeton",
  "FREE_FROM-ALCOHOL": "Alkoholiton",
  "FREE_FROM-ANTIBIOTICS": "Antibioottivapaa",
  "FREE_FROM-AZO_DYE": "Ei sisällä atsovärejä",
  "FREE_FROM-CAFFEINE": "Kofeiiniton",
  "FREE_FROM-COLOURING_AGENTS": "Ei sisällä väriä lisäaineena",
  "FREE_FROM-EGGS": "Kananmunaton",
  "FREE_FROM-ENERGY": "Energiaton",
  "FREE_FROM-FAT": "Rasvaton",
  "FREE_FROM-GELATINE": "Ei sisällä liivatetta",
  "FREE_FROM-GLUTEN": "Gluteeniton",
  "FREE_FROM-LACTOSE": "Laktoositon",
  "FREE_FROM-MILK": "Maidoton",
  "FREE_FROM-NUTS": "Ei sisällä pähkinää",
  "FREE_FROM-PORK_GELATINE": "Ei sisällä liivatetta siasta",
  "FREE_FROM-BEEF_GELATINE": "Ei sisällä liivatetta naudasta",
  "FREE_FROM-PRESERVATIVES": "Säilöntäaineeton",
  "FREE_FROM-SODIUM_SALT": "Suolaton",
  "FREE_FROM-SUGARS": "Sokeriton",
  "FREE_FROM-YEAST": "Hiivaton",
  "HIGH-FIBRE": "Runsaskuituinen",
  "HIGH-SODIUM_SALT": "Voimakassuolainen",
  "LOW-FAT": "Vähärasvainen",
  "LOW-LACTOSE": "Vähälaktoosinen",
  "LOW-SATURATED_FAT": "Vähän tyydyttyneitä rasvoja",
  "LOW-SODIUM_SALT": "Vähän natriumia sisältävä/vähäsuolainen",
  "LOW-SUGARS": "Vähäsokerinen",
  "NO_ADDED-SUGARS": "Ei lisättyä sokeria",
  GOODS_FROM_FINLAND_BLUE_SWAN: hr,
  FINNISH_HEART_SYMBOL: Rr,
  VEGAN: fr,
  MADE_IN_FINLAND_FLAG_WITH_KEY: Tr,
  EU_ORGANIC_FARMING: Ir,
  EU_ECO_LABEL: gr,
  FAIR_TRADE_MARK: Nr,
  RAINFOREST_ALLIANCE: Or,
  RAINFOREST_ALLIANCE_PEOPLE_NATURE: Sr,
  RAINFOREST_ALLIANCE_INFO: kr,
  RAINFOREST_ALLIANCE_ICON: Lr,
  PUHTAASTI_KOTIMAINEN: Cr,
  SVANEN: yr,
  close: vr,
  SAFETY_DATA_SHEET: br,
  FOOD_CONTACT_CONFORMITY_CERTIFICATE: Mr,
  IFU: Vr
}, Gr = {
  sv: $o,
  en: Se,
  fi: Ur
}, Dr = a(null), Kr = ({ locale: t, children: s }) => {
  const n = i(() => Gr[t], [t]), e = i(
    () => ({ locale: t, translations: n }),
    [t, n]
  );
  return /* @__PURE__ */ o(Dr.Provider, { value: e, children: /* @__PURE__ */ o("div", { className: c.root, children: s }) });
};
export {
  Kr as KCCLocaleProvider,
  Dr as LocaleContext
};
